import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import arrayMutators from 'final-form-arrays';

import { LocationFormProps, LocationCreateFormData, LocationCreatePageProps } from './types';
import { LocationCreateFormRenderComponent } from './LocationCreateFormRenderComponent';

import { validateLocationForm } from '../validation';

export const LocationCreatePage: React.FC<LocationCreatePageProps> = ({ locationCreate }) => {
  const renderForm: LocationFormProps['render'] = React.useCallback(
    ({ handleSubmit, valid, dirtySinceLastSubmit }: FormRenderProps<LocationCreateFormData>) => {
      return (
        <LocationCreateFormRenderComponent
          handleSubmit={handleSubmit}
          valid={valid || dirtySinceLastSubmit}
        />
      );
    },
    [],
  );
  return (
    <Form<LocationCreateFormData>
      onSubmit={locationCreate}
      render={renderForm}
      validate={validateLocationForm}
      mutators={{ ...arrayMutators }}
    />
  );
};

export default LocationCreatePage;
